import * as actions from './actions';
import * as dealActions from 'bundles/apex/deals/show/store/deal/actions';
import * as generalActions from 'bundles/apex/deals/show/store/activities/actions';

export default function(state = {}, action) {
  switch (action.type) {

  case actions.ACTIVITIES_LOAD_STARTED:
    return {
      abortController: action.abortController,
      loading: true,
    };

  case actions.SET_ACTIVITIES:
    return {
      ...state,
      activities: action.activities,
      loading: false,
    };

  case generalActions.ADD_ACTIVITY:
    return {
      ...state,
      activities: [action.activity, ...state.activities],
    };

  // Changes to contacts may result in their IDs being changed, which may change activity tags on
  // the backend - clear search results to force tags to reload with updated data
  case dealActions.CHANGE_CONTACT_ROLE:
  case dealActions.UPDATE_CONTACT:
    return {
      ...state,
      activities: null,
    };

  default:
    return state;
  }
}
